
import { createContext } from "react"
import { useAuthenticatedUser } from "@/hooks/data/useAuthenticatedUser";

export interface IAuthContext extends ReturnType<typeof useAuthenticatedUser> { }

export const AuthContext = createContext<IAuthContext>({
    data: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default AuthContext;